// extracted by mini-css-extract-plugin
export default {"container":"date_container__3jInb"};